import Vue from "vue"
import * as VueGoogleMaps from "vue2-google-maps"

Vue.use(VueGoogleMaps, {
	load: {
		// key: "AIzaSyDwfZAkvi1CjoRTeo0G3hB7bl9hY1HVh_o",
		key: "AIzaSyAxOb6zjklEi4qhEGOmEsfqZZNTH8FQd9c",
		libraries: "places",
		region: "ID",
		language: "id",
	},
  installComponents: true
})

export default VueGoogleMaps